import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router';

import { CookieBanner } from 'src/components';

export const Route = createFileRoute('/_public')({
  component: () => {
    const isLogin = useMatch({ from: '/_public/login', shouldThrow: false });

    return (
      <>
        <Outlet />
        {!isLogin && <CookieBanner />}
      </>
    );
  },
});
